import CompanyList from "../components/company/CompanyList";

const CompanyPage = () => {
  return <CompanyList />;
};

export default CompanyPage;
